import { useLanguage } from '@/contexts/LanguageContext';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Lightbulb, Package, Trophy, BarChart3, Award, Users,
  Briefcase, Bot, ClipboardList, Handshake, Heart, Settings, Home, Images
} from 'lucide-react';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';

const DashboardSidebar = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  const items = [
    { title: t('الرئيسية', 'Home'), url: '/', icon: Home },
    { title: t('حاضنة الابتكار', 'Innovation Hub'), url: '/innovation', icon: Lightbulb },
    { title: t('صندوق الأفكار', 'Idea Box'), url: '/ideas', icon: Package },
    { title: t('التحدي الشهري', 'Monthly Challenge'), url: '/challenge', icon: Trophy },
    { title: t('لوحة المتصدرين', 'Leaderboard'), url: '/leaderboard', icon: BarChart3 },
    { title: t('إنجازات الكفاح', 'Achievements'), url: '/achievements', icon: Award },
    { title: t('معرض الصور', 'Photo Gallery'), url: '/gallery', icon: Images },
    { title: t('تبادل المهارات', 'Skill Exchange'), url: '/skills', icon: Users },
    { title: t('تبادل الخبرات المهنية', 'Expert Mentors'), url: '/experts', icon: Briefcase },
    { title: t('الكفاح الذكي', 'Smart Kifah'), url: '/smart', icon: Bot },
    { title: t('تقييم الفعاليات', 'Events Calendar'), url: '/events', icon: ClipboardList },
    { title: t('الشراكة المجتمعية', 'Partnerships'), url: '/partnerships', icon: Handshake },
    { title: t('زاوية الدعم النفسي', 'Mental Health'), url: '/mental-health', icon: Heart },
    { title: t('لوحة الإدارة', 'Admin Dashboard'), url: '/admin', icon: Settings },
  ];

  return (
    <Sidebar collapsible="offcanvas" side="right" className="border-l border-border">
      <SidebarContent className="pt-4">
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {items.map((item) => {
                const isActive = location.pathname === item.url;
                return (
                  <SidebarMenuItem key={item.url}>
                    <SidebarMenuButton
                      onClick={() => navigate(item.url)}
                      className={`flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all text-sm font-medium ${
                        isActive
                          ? 'bg-primary text-primary-foreground shadow-md'
                          : 'hover:bg-muted/60 text-foreground'
                      }`}
                    >
                      <item.icon className="h-5 w-5 shrink-0" />
                      <span>{item.title}</span>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};

export default DashboardSidebar;
